module.exports = __webpack_public_path__ + "static/media/133-bolivia.1ca6384e.svg";